import { OrderPaymentsInfo } from '../../types';

import { RefundMethods } from './RefundUtils';
import getLoyaltyPointsPaymentCoverage from './getLoyaltyPointsPaymentCoverage';
import getLoyaltyPointsRefundOptions from './getLoyaltyPointsRefundOptions';

/** Resolve display options within the methods already permitted by the refund policy. */
export default function getRefundOptions(refundMethods: ReadonlyArray<RefundMethods>, order: OrderPaymentsInfo) {
  return getLoyaltyPointsRefundOptions(refundMethods, getLoyaltyPointsPaymentCoverage(order));
}
